import { useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';

export interface TotpActivateProps {
  uri: string;
  secret: string;
  onVerify: (code: string) => void;
}

export default function TotpActivate({ uri, secret, onVerify }: TotpActivateProps) {
  const [code, setCode] = useState('');
  const [showSecret, setShowSecret] = useState(false);

  const valid = /^\d{6}$/.test(code);

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!valid) return;
    onVerify(code);
  }

  return (
    <div className="space-y-5">
      <p className="text-sm text-ink-300">
        Scan this QR with Google Authenticator, Authy, 1Password, or any TOTP
        app, then enter the 6-digit code below to confirm.
      </p>

      <div className="flex flex-col items-center gap-4 rounded-xl border border-ink-800 bg-white p-6">
        <QRCodeSVG value={uri} size={200} level="M" marginSize={1} />
      </div>

      <button
        type="button"
        className="text-xs text-ink-400 hover:text-ink-100 underline"
        onClick={() => setShowSecret((v) => !v)}
      >
        {showSecret ? 'Hide' : "Can't scan? Show secret to type manually"}
      </button>
      {showSecret && (
        <div className="rounded-lg border border-ink-800 bg-ink-900/60 p-3 font-mono text-xs break-all text-ink-200">
          {secret}
        </div>
      )}

      <form onSubmit={handleSubmit} className="space-y-3">
        <label className="block text-sm font-medium text-ink-200">
          First 6-digit code
        </label>
        <input
          value={code}
          onChange={(e) => setCode(e.target.value)}
          inputMode="numeric"
          autoComplete="one-time-code"
          maxLength={6}
          pattern="[0-9]{6}"
          placeholder="123456"
          className="w-full rounded-lg border border-ink-800 bg-ink-900 px-4 py-3 text-center font-mono text-xl tracking-widest text-ink-50 focus:border-avo-500 focus:outline-none"
        />
        <button
          type="submit"
          disabled={!valid}
          className="w-full rounded-lg bg-avo-500 px-4 py-3 text-sm font-medium text-ink-950 hover:bg-avo-400 transition-colors disabled:opacity-50"
        >
          Verify and continue
        </button>
      </form>
    </div>
  );
}
